import pegasus from "../../build/global/js/00-pegasus";

window.expiredJobPostGrid = () => {
    return {
        showing_more: false,
        init(){
            const singleJobs = this.$el.querySelectorAll('.Expired__Jobs__Post-Grid-single');

            singleJobs.forEach(elem => {
                this.hideJobs(elem);
            });

            window.addEventListener('resize', () => {
                singleJobs.forEach(elem => {
                    this.hideJobs(elem);
                });
            })
        },
        hideJobs(elem){
            const benefitsContainer = elem.querySelector('.benefits-container');
            if(typeof benefitsContainer === 'undefined' || benefitsContainer === null){
                return;
            }
            const benefits = benefitsContainer.querySelectorAll('.benefit-tag:not(.hidden)');
            const benefitsHidden = benefitsContainer.querySelectorAll('.benefit-tag.hidden');
            let benefitsWidth = 0;
            let hiddenElements;
            const additionalBenefitsContainer = benefitsContainer.querySelector('.additional-benefits');

            hiddenElements = benefitsHidden.length;

            if(hiddenElements > 0){
                additionalBenefitsContainer.textContent = '+'+hiddenElements;
            } else {
                additionalBenefitsContainer.textContent = '';
            }

            benefits.forEach(benefit => {
                benefitsWidth += benefit.offsetWidth;
            })

            const containerRect = benefitsContainer.getBoundingClientRect();
            const availableSpace = containerRect.width - 100;

            if(benefitsWidth > availableSpace){
                benefits[benefits.length - 1].classList.add('hidden');
                this.hideJobs(elem);
            }

            benefitsHidden.forEach(hidden => {
                const elementWidth = this.getBoundingRect(hidden).width;

                if(benefitsWidth + elementWidth <= availableSpace){
                    hidden.classList.remove('hidden');
                }
            });

        },
        getBoundingRect(element) {
            const newElem = element.cloneNode(true);
            newElem.style.display = "inline-block";
            newElem.style.visibility = "hidden";
            document.body.appendChild(newElem);
            let rect = newElem.getBoundingClientRect();
            document.body.removeChild(newElem);
            return rect;
        },
    }
}